
/*
===============================================================================
biehistoricalworkbook.client.ts — canonical workbook template downlods
===============================================================================
*/

import {
  BieHistoricalWorkbookMode,
} from './biehistoricalworkbook.models';


const SERVICE = 'biehistoricalworkbook';
const TYPE = 'biehis';


// Downloads
export async function downloadHistoricalWorkbook(
  mode: BieHistoricalWorkbookMode,
  planningcycleid: number,
  historicaldatasetid?: number | null,
  gapkeys?: string[]
): Promise<void> {
  const payload = {
    s: SERVICE,
    a: 'export',

    ext: TYPE,
    mod: mode,
    pci: planningcycleid,
    hdi: historicaldatasetid ?? null,
    gks: gapkeys ?? null,
  };

  const response:any = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    //const {success,message} = resp.json();
    const err: any = await response.text();
    console.log('fileBiz.resp.error:', err);
    return Promise.reject(err.message || err || 'request failed...');
  }
  const resdata = await response.blob();

  const disposition = String(response.headers?.['content-disposition'] ?? '');
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const filename = match?.[1] ?? 'BPMMS_Historical_Data.xlsx';

  const blob = resdata instanceof Blob
    ? resdata
    : new Blob([resdata], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function downloadHistoricalTemplate(
  planningcycleid: number,
  historicaldatasetid?: number | null,
): Promise<void> {
  const mode = 'TEMPLATE';
  await downloadHistoricalWorkbook(mode,planningcycleid,historicaldatasetid);
}

export async function downloadAllHistoricalGaps(
  planningcycleid: number,
  historicaldatasetid?: number | null,
): Promise<void> {
  const mode = 'ALL_GAPS';
  await downloadHistoricalWorkbook(mode, planningcycleid, historicaldatasetid);
}

export async function downloadSelectedHistoricalGaps(
  planningcycleid: number,
  gapkeys: string[],
  historicaldatasetid?: number | null,
): Promise<void> {
  const uniqueGapKeys = Array.from(
    new Set(
      (gapkeys ?? [])
        .map((key) => String(key ?? '').trim())
        .filter(Boolean),
    ),
  );

  if (uniqueGapKeys.length === 0) {
    throw new Error('Select at least one historical gap to download.');
  }

  await downloadHistoricalWorkbook(
    'SELECTED_GAPS',
    planningcycleid,
    historicaldatasetid,
    uniqueGapKeys,
  );
}


















// /*
// ===============================================================================
// biehistoricalworkbook.apis.ts

// Direct client API functions for:
//     service: biehistorical

// The middleware upload extension converts the framework file-upload request
// into the PostgreSQL workbook-upload contract.
// ===============================================================================
// */

// import { generateTrackId, json, postBiz, uploadBiz } from '../core/coreapi';

// import {
//   BieHistoricalWorkbookOperationResult,
//   BieHistoricalWorkbookReview,
//   BieHistoricalWorkbookUploadRequest,
// } from './biehistoricalworkbook.models';

// import {
//   normalizeBieHistoricalWorkbookOperation,
//   normalizeBieHistoricalWorkbookReview,
// } from './biehistoricalworkbook.normalizers';

// const SERVICE = 'biehistoricalworkbook';

// /*
//  * This should match the registered BieHistoricalWorkbookParser prefix.
//  */
// const UPLOAD_PREFIX = 'biehis';

// export async function reviewBieHistoricalWorkbook(
//   planningcycleid: number
// ): Promise<BieHistoricalWorkbookReview> {
//   const response = await postBiz({
//     s: SERVICE,
//     a: 'review',
//     pci: planningcycleid,
//   });

//   return normalizeBieHistoricalWorkbookReview(json(response));
// }

// export async function uploadBieHistoricalWorkbook0(
//   request: BieHistoricalWorkbookUploadRequest
// ): Promise<BieHistoricalWorkbookOperationResult> {
//   const response = await uploadBiz({
//     service: SERVICE,
//     action: 'upload',

//     prefix: UPLOAD_PREFIX,

//     file: request.file,

//     params: {
//       tki: request.trackId ?? generateTrackId(),
//       pci: request.planningcycleid,
//       rex: request.replaceExisting ? 1 : 0,
//       rmk: request.remarks || '',
//     }

    
//   } as any);

//   return normalizeBieHistoricalWorkbookOperation(json(response));
// }

// export async function uploadBieHistoricalWorkbook(
//   request: BieHistoricalWorkbookUploadRequest
// ): Promise<any> {
//   const response = await uploadBiz({
//     service: SERVICE,
//     action: 'upload',

//     prefix: UPLOAD_PREFIX,

//     file: request.file,

//     params: {
//       tki: request.trackId ?? generateTrackId(),
//       pci: request.planningcycleid,
//       hdi: request.historicaldatasetid,
//       rex: request.replaceExisting ? 1 : 0,
//       rmk: request.remarks || '',
//     }


//   } as any);

//   return normalizeBieHistoricalWorkbookOperation(json(response));
// }

// export async function validateBieHistoricalWorkbook(
//   planningcycleid: number,
//   stamp: string
// ): Promise<BieHistoricalWorkbookOperationResult> {
//   const response = await postBiz({
//     s: SERVICE,
//     a: 'validate',
//     pci: planningcycleid,
//     stp: stamp,
//   });

//   return normalizeBieHistoricalWorkbookOperation(json(response));
// }
